import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      // Brand
      "brand.name": "Kanama",
      "brand.tagline": "Votre guide pour explorer le meilleur du Tchad, accessible à tous",
      "brand.tagline.short": "Votre guide du Tchad",

      // Nav
      "nav.home": "Accueil",
      "nav.categories": "Catégories",
      "nav.map": "Carte",
      "nav.admin": "Administration",
      "nav.login": "Connexion",
      "nav.register": "Inscription",
      "nav.logout": "Déconnexion",
      "nav.pricing": "Tarifs",
      "nav.regions": "Régions",
      "nav.becomeOwner": "Devenir annonceur",
      "nav.ownerDashboard": "Mon espace pro",
      "nav.more": "Plus",
      "bottomNav.home": "Accueil",
      "bottomNav.map": "Carte",
      "bottomNav.ride": "Ride",
      "bottomNav.regions": "Régions",
      "bottomNav.pricing": "Tarifs",
      "bottomNav.account": "Compte",
      "bottomNav.signIn": "Connexion",
      "bottomNav.regions.sheetTitle": "Choisissez une région",
      "bottomNav.regions.viewAll": "Voir toutes les annonces sur la carte",

      // Categories
      "cat.restaurant": "Restaurants",
      "cat.bar": "Bars",
      "cat.hotel": "Hôtels",
      "cat.rental": "Locations",
      "cat.mechanic": "Mécaniciens",
      "cat.car_sale": "Vente de voitures",
      "cat.car_rental": "Location de voitures",
      "cat.travel_agency": "Agences de voyages",

      // Home
      "home.hero.title.line1": "Restaurants, hôtels, voitures et plus encore au",
      "home.hero.title.line2": "Tchad.",
      "home.hero.subtitle":
        "Trouvez des adresses fiables dans toutes les régions du Tchad — tous les services essentiels sur une carte interactive.",
      "home.hero.search.placeholder": "Rechercher : restaurant, hôtel, mécanicien, Toyota...",
      "home.hero.search.city.all": "Toutes les villes",
      "home.hero.search.cta": "Rechercher",
      "home.hero.viewMap": "Voir la carte interactive",
      "home.hero.listingsCount_one": "{{count}} adresse référencée",
      "home.hero.listingsCount_other": "{{count}} adresses référencées",

      "home.categories.label": "Explorez par catégorie",
      "home.categories.title": "Que cherchez-vous aujourd'hui ?",
      "home.tile.map.title": "Carte du Tchad",
      "home.tile.map.subtitle": "Toutes les annonces sur une carte interactive avec filtres.",
      "home.tile.map.cta": "Vue globale",
      "home.tile.count_one": "{{count}} annonce",
      "home.tile.count_other": "{{count}} annonces",

      "home.cities.label": "Régions et villes",
      "home.cities.title": "Présent dans toutes les régions du Tchad",
      "home.discover.label": "Découvrir le Tchad",
      "home.discover.title": "Des paysages d'exception, du Sahara aux savanes",
      "home.discover.subtitle": "Du plateau de l'Ennedi aux lacs d'Ounianga, en passant par la guelta d'Archei et la faune sauvage — le Tchad est l'un des secrets les mieux gardés d'Afrique.",
      "home.discover.guelta": "Guelta d'Archei",
      "home.discover.guelta.region": "Ennedi · Patrimoine UNESCO",
      "home.discover.wildlife": "Faune sauvage",
      "home.discover.wildlife.region": "Parcs nationaux",
      "home.discover.camels": "Caravane à la guelta",
      "home.discover.camels.region": "Massif de l'Ennedi",
      "home.discover.ounianga": "Lacs d'Ounianga",
      "home.discover.ounianga.region": "Borkou · Patrimoine UNESCO",
      "home.discover.ennedi": "Plateau de l'Ennedi",
      "home.discover.ennedi.region": "Désert du Sahara tchadien",
      "home.discover.cta": "Explorer les agences de voyages",

      // Common
      "common.allCities": "Toutes les villes",
      "common.allRegions": "Toutes les régions",
      "common.loading": "Chargement...",
      "common.search": "Rechercher",
      "common.clearFilters": "Effacer les filtres",
      "common.viewDetails": "Voir les détails",
      "common.back": "Retour",
      "common.cancel": "Annuler",
      "common.save": "Enregistrer",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.priority": "Prioritaires",
      "common.others": "Autres",
      "common.priceLabel": "Prix",
      "common.allPrices": "Tous les prix",
      "common.list": "Liste",
      "common.map": "Carte",
      "common.priceRange.cheap": "$ — Économique",
      "common.priceRange.moderate": "$$ — Modéré",
      "common.priceRange.high": "$$$ — Élevé",
      "common.priceRange.premium": "$$$$ — Premium",

      // Footer
      "footer.copyright": "© {{year}} Kanama · L'annuaire local du Tchad",
      "footer.regionsCities.label": "Régions et villes",
      "footer.regionsCities.title": "Explorez le Tchad — région par région",
      "footer.regionsCities.subtitle": "23 régions et 23 grandes villes, toutes accessibles en un clic.",
      "footer.regions.title": "Les {{count}} régions du Tchad",
      "footer.regions.capital": "Chef-lieu",
      "footer.cities.title": "{{count}} grandes villes du pays",
    },
  },
  en: {
    translation: {
      "brand.name": "Kanama",
      "brand.tagline": "Your guide to explore the best of Chad, accessible to all",
      "brand.tagline.short": "Your guide to Chad",

      "nav.home": "Home",
      "nav.categories": "Categories",
      "nav.map": "Map",
      "nav.admin": "Admin",
      "nav.login": "Sign in",
      "nav.register": "Sign up",
      "nav.logout": "Sign out",
      "nav.pricing": "Pricing",
      "nav.regions": "Regions",
      "nav.becomeOwner": "List your business",
      "nav.ownerDashboard": "Owner dashboard",
      "nav.more": "More",
      "bottomNav.home": "Home",
      "bottomNav.map": "Map",
      "bottomNav.ride": "Ride",
      "bottomNav.regions": "Regions",
      "bottomNav.pricing": "Pricing",
      "bottomNav.account": "Account",
      "bottomNav.signIn": "Sign in",
      "bottomNav.regions.sheetTitle": "Pick a region",
      "bottomNav.regions.viewAll": "Browse the full map",

      "cat.restaurant": "Restaurants",
      "cat.bar": "Bars",
      "cat.hotel": "Hotels",
      "cat.rental": "Rentals",
      "cat.mechanic": "Mechanics",
      "cat.car_sale": "Cars for sale",
      "cat.car_rental": "Car rentals",
      "cat.travel_agency": "Travel agencies",

      "home.hero.title.line1": "Restaurants, hotels, cars and much more in",
      "home.hero.title.line2": "Chad.",
      "home.hero.subtitle":
        "Find trusted addresses across all regions of Chad — every essential service on one interactive map.",
      "home.hero.search.placeholder": "Search: restaurant, hotel, mechanic, Toyota...",
      "home.hero.search.city.all": "All cities",
      "home.hero.search.cta": "Search",
      "home.hero.viewMap": "View the interactive map",
      "home.hero.listingsCount_one": "{{count}} listing",
      "home.hero.listingsCount_other": "{{count}} listings",

      "home.categories.label": "Explore by category",
      "home.categories.title": "What are you looking for today?",
      "home.tile.map.title": "Map of Chad",
      "home.tile.map.subtitle": "All listings on one interactive map with filters.",
      "home.tile.map.cta": "Global view",
      "home.tile.count_one": "{{count}} listing",
      "home.tile.count_other": "{{count}} listings",

      "home.cities.label": "Regions and cities",
      "home.cities.title": "Present in every region of Chad",
      "home.discover.label": "Discover Chad",
      "home.discover.title": "Exceptional landscapes, from the Sahara to the savannas",
      "home.discover.subtitle": "From the Ennedi plateau to the Ounianga lakes, the Archei guelta and rare wildlife — Chad is one of Africa's best-kept secrets.",
      "home.discover.guelta": "Guelta d'Archei",
      "home.discover.guelta.region": "Ennedi · UNESCO heritage",
      "home.discover.wildlife": "Wildlife",
      "home.discover.wildlife.region": "National parks",
      "home.discover.camels": "Caravan at the guelta",
      "home.discover.camels.region": "Ennedi massif",
      "home.discover.ounianga": "Lakes of Ounianga",
      "home.discover.ounianga.region": "Borkou · UNESCO heritage",
      "home.discover.ennedi": "Ennedi Plateau",
      "home.discover.ennedi.region": "Chadian Sahara",
      "home.discover.cta": "Explore travel agencies",

      "common.allCities": "All cities",
      "common.allRegions": "All regions",
      "common.loading": "Loading...",
      "common.search": "Search",
      "common.clearFilters": "Clear filters",
      "common.viewDetails": "View details",
      "common.back": "Back",
      "common.cancel": "Cancel",
      "common.save": "Save",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.priority": "Priority",
      "common.others": "Others",
      "common.priceLabel": "Price",
      "common.allPrices": "All prices",
      "common.list": "List",
      "common.map": "Map",
      "common.priceRange.cheap": "$ — Budget",
      "common.priceRange.moderate": "$$ — Moderate",
      "common.priceRange.high": "$$$ — High",
      "common.priceRange.premium": "$$$$ — Premium",

      "footer.copyright": "© {{year}} Kanama · Local directory of Chad",
      "footer.regionsCities.label": "Regions & cities",
      "footer.regionsCities.title": "Explore Chad — region by region",
      "footer.regionsCities.subtitle": "23 regions and 23 major cities — all one click away.",
      "footer.regions.title": "The {{count}} regions of Chad",
      "footer.regions.capital": "Capital",
      "footer.cities.title": "{{count}} major cities",
    },
  },
  ar: {
    translation: {
      "brand.name": "كناما",
      "brand.tagline": "دليلك لاستكشاف أفضل ما في تشاد، في متناول الجميع",
      "brand.tagline.short": "دليلك إلى تشاد",

      "nav.home": "الرئيسية",
      "nav.categories": "الفئات",
      "nav.map": "الخريطة",
      "nav.admin": "الإدارة",
      "nav.login": "تسجيل الدخول",
      "nav.register": "إنشاء حساب",
      "nav.logout": "تسجيل الخروج",
      "nav.pricing": "الأسعار",
      "nav.regions": "المناطق",
      "nav.becomeOwner": "أضف نشاطك التجاري",
      "nav.ownerDashboard": "لوحة المعلن",
      "nav.more": "المزيد",
      "bottomNav.home": "الرئيسية",
      "bottomNav.map": "الخريطة",
      "bottomNav.ride": "ركوب",
      "bottomNav.regions": "المناطق",
      "bottomNav.pricing": "الأسعار",
      "bottomNav.account": "حسابي",
      "bottomNav.signIn": "تسجيل الدخول",
      "bottomNav.regions.sheetTitle": "اختر منطقة",
      "bottomNav.regions.viewAll": "تصفح الخريطة الكاملة",

      "cat.restaurant": "مطاعم",
      "cat.bar": "بارات",
      "cat.hotel": "فنادق",
      "cat.rental": "إيجار سكن",
      "cat.mechanic": "ميكانيكيون",
      "cat.car_sale": "بيع سيارات",
      "cat.car_rental": "تأجير سيارات",
      "cat.travel_agency": "وكالات السفر",

      "home.hero.title.line1": "مطاعم وفنادق وسيارات والمزيد في",
      "home.hero.title.line2": "تشاد.",
      "home.hero.subtitle":
        "اعثر على عناوين موثوقة في جميع مناطق تشاد — كل الخدمات الأساسية على خريطة تفاعلية واحدة.",
      "home.hero.search.placeholder": "ابحث: مطعم، فندق، ميكانيكي، تويوتا...",
      "home.hero.search.city.all": "كل المدن",
      "home.hero.search.cta": "بحث",
      "home.hero.viewMap": "عرض الخريطة التفاعلية",
      "home.hero.listingsCount_one": "{{count}} إعلان",
      "home.hero.listingsCount_other": "{{count}} إعلانات",

      "home.categories.label": "استكشف حسب الفئة",
      "home.categories.title": "عماذا تبحث اليوم؟",
      "home.tile.map.title": "خريطة تشاد",
      "home.tile.map.subtitle": "كل الإعلانات على خريطة تفاعلية واحدة مع فلاتر.",
      "home.tile.map.cta": "عرض شامل",
      "home.tile.count_one": "{{count}} إعلان",
      "home.tile.count_other": "{{count}} إعلانات",

      "home.cities.label": "المناطق والمدن",
      "home.cities.title": "حاضرون في جميع مناطق تشاد",
      "home.discover.label": "اكتشف تشاد",
      "home.discover.title": "مناظر استثنائية، من الصحراء إلى السافانا",
      "home.discover.subtitle": "من هضبة إنيدي إلى بحيرات أونيانغا، مرورًا بقُلتة أرشي والحياة البرية النادرة — تشاد من أفضل أسرار إفريقيا الخفية.",
      "home.discover.guelta": "قُلتة أرشي",
      "home.discover.guelta.region": "إنيدي · تراث اليونسكو",
      "home.discover.wildlife": "الحياة البرية",
      "home.discover.wildlife.region": "الحدائق الوطنية",
      "home.discover.camels": "قافلة عند القُلتة",
      "home.discover.camels.region": "كتلة إنيدي الجبلية",
      "home.discover.ounianga": "بحيرات أونيانغا",
      "home.discover.ounianga.region": "بوركو · تراث اليونسكو",
      "home.discover.ennedi": "هضبة إنيدي",
      "home.discover.ennedi.region": "صحراء تشاد",
      "home.discover.cta": "استكشف وكالات السفر",

      "common.allCities": "كل المدن",
      "common.allRegions": "كل المناطق",
      "common.loading": "جاري التحميل...",
      "common.search": "بحث",
      "common.clearFilters": "مسح الفلاتر",
      "common.viewDetails": "عرض التفاصيل",
      "common.back": "رجوع",
      "common.cancel": "إلغاء",
      "common.save": "حفظ",
      "common.delete": "حذف",
      "common.edit": "تعديل",
      "common.priority": "ذات أولوية",
      "common.others": "أخرى",
      "common.priceLabel": "السعر",
      "common.allPrices": "كل الأسعار",
      "common.list": "قائمة",
      "common.map": "خريطة",
      "common.priceRange.cheap": "$ — اقتصادي",
      "common.priceRange.moderate": "$$ — متوسط",
      "common.priceRange.high": "$$$ — مرتفع",
      "common.priceRange.premium": "$$$$ — فاخر",

      "footer.copyright": "© {{year}} كناما · دليل تشاد المحلي",
      "footer.regionsCities.label": "المناطق والمدن",
      "footer.regionsCities.title": "اكتشف تشاد منطقة تلو الأخرى",
      "footer.regionsCities.subtitle": "23 منطقة و23 مدينة كبرى، كلها بنقرة واحدة.",
      "footer.regions.title": "مناطق تشاد الـ{{count}}",
      "footer.regions.capital": "العاصمة",
      "footer.cities.title": "{{count}} مدينة رئيسية",
    },
  },
  es: {
    translation: {
      "brand.name": "Kanama",
      "brand.tagline": "Tu guía para explorar lo mejor de Chad, accesible para todos",
      "brand.tagline.short": "Tu guía de Chad",

      "nav.home": "Inicio",
      "nav.categories": "Categorías",
      "nav.map": "Mapa",
      "nav.admin": "Administración",
      "nav.login": "Iniciar sesión",
      "nav.register": "Registrarse",
      "nav.logout": "Cerrar sesión",
      "nav.pricing": "Precios",
      "nav.regions": "Regiones",
      "nav.becomeOwner": "Anuncia tu negocio",
      "nav.ownerDashboard": "Panel del anunciante",
      "nav.more": "Más",
      "bottomNav.home": "Inicio",
      "bottomNav.map": "Mapa",
      "bottomNav.ride": "Ride",
      "bottomNav.regions": "Regiones",
      "bottomNav.pricing": "Precios",
      "bottomNav.account": "Cuenta",
      "bottomNav.signIn": "Entrar",
      "bottomNav.regions.sheetTitle": "Elige una región",
      "bottomNav.regions.viewAll": "Ver todo en el mapa",

      "cat.restaurant": "Restaurantes",
      "cat.bar": "Bares",
      "cat.hotel": "Hoteles",
      "cat.rental": "Alquileres",
      "cat.mechanic": "Mecánicos",
      "cat.car_sale": "Venta de coches",
      "cat.car_rental": "Alquiler de coches",
      "cat.travel_agency": "Agencias de viajes",

      "home.hero.title.line1": "Restaurantes, hoteles, coches y mucho más en",
      "home.hero.title.line2": "Chad.",
      "home.hero.subtitle":
        "Encuentra direcciones confiables en todas las regiones de Chad — todos los servicios esenciales en un mapa interactivo.",
      "home.hero.search.placeholder": "Buscar: restaurante, hotel, mecánico, Toyota...",
      "home.hero.search.city.all": "Todas las ciudades",
      "home.hero.search.cta": "Buscar",
      "home.hero.viewMap": "Ver el mapa interactivo",
      "home.hero.listingsCount_one": "{{count}} anuncio",
      "home.hero.listingsCount_other": "{{count}} anuncios",

      "home.categories.label": "Explora por categoría",
      "home.categories.title": "¿Qué buscas hoy?",
      "home.tile.map.title": "Mapa de Chad",
      "home.tile.map.subtitle": "Todos los anuncios en un mapa interactivo con filtros.",
      "home.tile.map.cta": "Vista global",
      "home.tile.count_one": "{{count}} anuncio",
      "home.tile.count_other": "{{count}} anuncios",

      "home.cities.label": "Regiones y ciudades",
      "home.cities.title": "Presente en todas las regiones de Chad",
      "home.discover.label": "Descubre Chad",
      "home.discover.title": "Paisajes excepcionales, del Sáhara a las sabanas",
      "home.discover.subtitle": "Del meseta de Ennedi a los lagos de Ounianga, pasando por la guelta de Archei y la fauna rara — Chad es uno de los secretos mejor guardados de África.",
      "home.discover.guelta": "Guelta de Archei",
      "home.discover.guelta.region": "Ennedi · Patrimonio UNESCO",
      "home.discover.wildlife": "Fauna salvaje",
      "home.discover.wildlife.region": "Parques nacionales",
      "home.discover.camels": "Caravana en la guelta",
      "home.discover.camels.region": "Macizo de Ennedi",
      "home.discover.ounianga": "Lagos de Ounianga",
      "home.discover.ounianga.region": "Borkou · Patrimonio UNESCO",
      "home.discover.ennedi": "Meseta de Ennedi",
      "home.discover.ennedi.region": "Sáhara chadiano",
      "home.discover.cta": "Explorar agencias de viajes",

      "common.allCities": "Todas las ciudades",
      "common.allRegions": "Todas las regiones",
      "common.loading": "Cargando...",
      "common.search": "Buscar",
      "common.clearFilters": "Borrar filtros",
      "common.viewDetails": "Ver detalles",
      "common.back": "Volver",
      "common.cancel": "Cancelar",
      "common.save": "Guardar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.priority": "Prioritarias",
      "common.others": "Otras",
      "common.priceLabel": "Precio",
      "common.allPrices": "Todos los precios",
      "common.list": "Lista",
      "common.map": "Mapa",
      "common.priceRange.cheap": "$ — Económico",
      "common.priceRange.moderate": "$$ — Moderado",
      "common.priceRange.high": "$$$ — Alto",
      "common.priceRange.premium": "$$$$ — Premium",

      "footer.copyright": "© {{year}} Kanama · Directorio local de Chad",
      "footer.regionsCities.label": "Regiones y ciudades",
      "footer.regionsCities.title": "Explora Chad — región por región",
      "footer.regionsCities.subtitle": "23 regiones y 23 ciudades principales — todo a un clic.",
      "footer.regions.title": "Las {{count}} regiones de Chad",
      "footer.regions.capital": "Capital",
      "footer.cities.title": "{{count}} ciudades principales",
    },
  },
  zh: {
    translation: {
      "brand.name": "Kanama",
      "brand.tagline": "您探索乍得最佳之地的指南，人人可用",
      "brand.tagline.short": "您的乍得指南",

      "nav.home": "首页",
      "nav.categories": "分类",
      "nav.map": "地图",
      "nav.admin": "管理",
      "nav.login": "登录",
      "nav.register": "注册",
      "nav.logout": "退出",
      "nav.pricing": "价格",
      "nav.regions": "地区",
      "nav.becomeOwner": "发布您的业务",
      "nav.ownerDashboard": "商家中心",
      "nav.more": "更多",
      "bottomNav.home": "首页",
      "bottomNav.map": "地图",
      "bottomNav.ride": "出行",
      "bottomNav.regions": "地区",
      "bottomNav.pricing": "价格",
      "bottomNav.account": "账户",
      "bottomNav.signIn": "登录",
      "bottomNav.regions.sheetTitle": "选择地区",
      "bottomNav.regions.viewAll": "查看完整地图",

      "cat.restaurant": "餐厅",
      "cat.bar": "酒吧",
      "cat.hotel": "酒店",
      "cat.rental": "房屋租赁",
      "cat.mechanic": "汽修",
      "cat.car_sale": "汽车销售",
      "cat.car_rental": "汽车租赁",
      "cat.travel_agency": "旅行社",

      "home.hero.title.line1": "餐厅、酒店、汽车及更多服务尽在",
      "home.hero.title.line2": "乍得。",
      "home.hero.subtitle":
        "在乍得所有地区找到可靠的地址 — 所有基本服务都在一张互动地图上。",
      "home.hero.search.placeholder": "搜索：餐厅、酒店、汽修、丰田……",
      "home.hero.search.city.all": "所有城市",
      "home.hero.search.cta": "搜索",
      "home.hero.viewMap": "查看互动地图",
      "home.hero.listingsCount_one": "{{count}} 条记录",
      "home.hero.listingsCount_other": "{{count}} 条记录",

      "home.categories.label": "按分类浏览",
      "home.categories.title": "您今天想找什么？",
      "home.tile.map.title": "乍得地图",
      "home.tile.map.subtitle": "所有信息汇集于一张可筛选的互动地图。",
      "home.tile.map.cta": "全局视图",
      "home.tile.count_one": "{{count}} 条",
      "home.tile.count_other": "{{count}} 条",

      "home.cities.label": "地区与城市",
      "home.cities.title": "覆盖乍得所有地区",
      "home.discover.label": "探索乍得",
      "home.discover.title": "从撒哈拉到热带草原，绝美风光",
      "home.discover.subtitle": "从恩内迪高原到乌尼扬加湖群，再到阿尔谢峡谷与珍稀野生动物 — 乍得是非洲最珍藏的秘境之一。",
      "home.discover.guelta": "阿尔谢峡谷",
      "home.discover.guelta.region": "恩内迪 · 联合国教科文遗产",
      "home.discover.wildlife": "野生动物",
      "home.discover.wildlife.region": "国家公园",
      "home.discover.camels": "峡谷骆驼商队",
      "home.discover.camels.region": "恩内迪山脉",
      "home.discover.ounianga": "乌尼扬加湖群",
      "home.discover.ounianga.region": "博尔库 · 联合国教科文遗产",
      "home.discover.ennedi": "恩内迪高原",
      "home.discover.ennedi.region": "乍得撒哈拉",
      "home.discover.cta": "浏览旅行社",

      "common.allCities": "所有城市",
      "common.allRegions": "所有地区",
      "common.loading": "加载中...",
      "common.search": "搜索",
      "common.clearFilters": "清除筛选",
      "common.viewDetails": "查看详情",
      "common.back": "返回",
      "common.cancel": "取消",
      "common.save": "保存",
      "common.delete": "删除",
      "common.edit": "编辑",
      "common.priority": "重点",
      "common.others": "其他",
      "common.priceLabel": "价格",
      "common.allPrices": "所有价位",
      "common.list": "列表",
      "common.map": "地图",
      "common.priceRange.cheap": "$ — 经济",
      "common.priceRange.moderate": "$$ — 中等",
      "common.priceRange.high": "$$$ — 较高",
      "common.priceRange.premium": "$$$$ — 顶级",

      "footer.copyright": "© {{year}} Kanama · 乍得本地指南",
      "footer.regionsCities.label": "地区与城市",
      "footer.regionsCities.title": "逐区探索乍得",
      "footer.regionsCities.subtitle": "23 个地区，23 座主要城市 — 一键直达。",
      "footer.regions.title": "乍得的 {{count}} 个地区",
      "footer.regions.capital": "首府",
      "footer.cities.title": "{{count}} 座主要城市",
    },
  },
};

export const SUPPORTED_LANGS = [
  { code: "fr", label: "Français", short: "FR", flag: "🇫🇷" },
  { code: "en", label: "English", short: "EN", flag: "🇬🇧" },
  { code: "ar", label: "العربية", short: "AR", flag: "🇸🇦", rtl: true },
  { code: "es", label: "Español", short: "ES", flag: "🇪🇸" },
  { code: "zh", label: "中文", short: "ZH", flag: "🇨🇳" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "kanama_lang",
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// Apply RTL direction when language changes
i18n.on("languageChanged", (lng) => {
  const lang = SUPPORTED_LANGS.find((l) => l.code === lng);
  document.documentElement.dir = lang?.rtl ? "rtl" : "ltr";
  document.documentElement.lang = lng;
});

// Initial direction
const initial = SUPPORTED_LANGS.find((l) => l.code === i18n.language);
if (typeof document !== "undefined") {
  document.documentElement.dir = initial?.rtl ? "rtl" : "ltr";
  document.documentElement.lang = i18n.language;
}

export default i18n;
